import api from 'api/apiInstance';

export function clientCaseDocumentViewApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
